// Regolamento ufficiale Coppa dei Club 2026-27 (sintesi fedele degli articoli; il PDF scaricabile fa fede)
export const REGOLAMENTO = [
  {
    n: 1,
    title: "Ammissione",
    points: [
      "Possono partecipare squadre di A.S.D. o S.S.D. affiliate a MSP Italia per il 2026/2027, con almeno un campo di gioco disponibile e giocatori tesserati con Violet Card (A1) o Orange Card (A2).",
      "Ogni tesserato deve fornire certificazione medica per attività sportiva non agonistica (o agonistica padel).",
      "Iscrizione tramite modulo del Comitato MSP Italia da inviare a coppadeiclubumbria@gmail.com insieme alla distinta di pagamento.",
      "Quota di iscrizione: 170 € (1 squadra), 300 € (2), 420 € (3), 520 € (4), 600 € (5) — bonifico a MSP Italia Umbria, IBAN IT64B0307502200CC8500906891.",
      "Formula: 1ª fase a gironi Gold/Silver League (ottobre–dicembre 2026), 2ª fase Gold Cup / Silver Cup / Bronze Cup (gennaio–aprile 2027), poi playoff fino alla finale.",
    ],
  },
  {
    n: 2,
    title: "Limitazioni alla partecipazione dei giocatori",
    points: [
      "Possono partecipare giocatori di 3ª, 4ª e 5ª categoria; ogni squadra deve essere composta obbligatoriamente da atleti di categorie miste.",
      "In ogni gara non possono essere schierati più di 5 atleti di 3ª categoria.",
      "Non possono disputare la competizione: giocatori FITP padel oltre la 3ª fascia, ex 1ª/2ª categoria tennis negli ultimi 5 anni (salvo eccezioni per età), Maestri/Istruttori/Tecnici Nazionali, stranieri che collaborano all'insegnamento nel club.",
      "La competizione è aperta anche a giocatori con disabilità motoria, con regole di schieramento dedicate e cambio sede obbligatorio se manca l'accessibilità.",
      "Irregolarità nello schieramento comportano la perdita della singola partita; in caso di reiterazione, sconfitta 4-0 senza possibilità di ripetizione.",
    ],
  },
  {
    n: "2 bis",
    title: "Regolamento per le Finali Nazionali",
    points: [
      "Per la fase finale nazionale si applica esclusivamente il Regolamento Nazionale Padel MSP Italia, accettato integralmente con la qualificazione.",
    ],
  },
  {
    n: 3,
    title: "Modalità di iscrizione e responsabilità del club",
    points: [
      "Iscrizione entro e non oltre il 10 settembre 2026, con denominazione dell'affiliato, ubicazione dei campi e lista giocatori.",
      "Ogni lista comprende da un minimo di 16 a un massimo di 35 giocatori (misti).",
      "Ogni club tesserà autonomamente i propri atleti e richiederà la certificazione medica idonea.",
    ],
  },
  {
    n: 4,
    title: "Composizione e gestione liste squadre",
    points: [
      "Le squadre si iscrivono a Gold League o Silver League; al termine della 1ª fase sono ridistribuite in Gold Cup, Silver Cup e Bronze Cup.",
      "Le liste possono essere integrate fino alla terzultima giornata delle fasi a gironi; le integrazioni vanno comunicate entro le 13:00 del mercoledì precedente la giornata di gioco.",
      "Un giocatore può passare a un'altra squadra solo nella pausa natalizia e solo se schierato al massimo una volta.",
      "Alle finali regionali possono giocare solo atleti già scesi in campo almeno una giornata.",
    ],
  },
  {
    n: 5,
    title: "Formula di svolgimento del campionato",
    points: [
      "Quota campo: 72 € a squadra, dovuta per intero anche con meno di 8 atleti o in caso di mancata presentazione senza preavviso.",
      "1ª fase: due campionati paralleli, Gold League e Silver League, divisi in gironi geografici.",
      "2ª fase: accesso a Gold Cup, Silver Cup o Bronze Cup in base al piazzamento in classifica.",
    ],
  },
  {
    n: 6,
    title: "Formula di svolgimento degli incontri",
    points: [
      "Ogni giornata prevede 4 incontri: maschile, femminile, maschile, misto (ordine variabile solo con accordo tra capitani).",
      "Ogni giocatore può disputare al massimo 1 incontro a giornata (escluso l'eventuale spareggio).",
      "Incontri al meglio dei 3 set a 6 game, con Golden Point obbligatorio, tie-break a 7 sul 6 pari e terzo set con Long Tie-break a 10.",
      "Nell'incontro misto il Golden Point si gioca con battitore e ribattitore dello stesso sesso.",
    ],
  },
  {
    n: 7,
    title: "Doppio di spareggio in caso di parità",
    points: [
      "Nelle fasi a eliminazione diretta lo spareggio è un doppio maschile, giocato solo da atleti schierati in formazione.",
      "La formazione dello spareggio va presentata entro 10 minuti dall'ultimo incontro; il match inizia al massimo 30 minuti dopo.",
    ],
  },
  {
    n: 8,
    title: "Formula degli incontri individuali",
    points: [
      "Alla presentazione delle formazioni devono essere presenti almeno 6 giocatori perché la squadra sia considerata presente.",
      "Assenze non comunicate agli avversari: decurtazione di 2 punti. Presentarsi con 6 giocatori: -1 punto in classifica.",
      "Per ogni incontro individuale non schierato: -1 punto. Assenza totale: -2 punti e sconfitta 4-0; due assenze totali equivalgono al ritiro dal campionato.",
      "Chi entra in campo accetta il risultato senza riserve, anche rifiutando di firmare il foglio unico.",
    ],
  },
  {
    n: 9,
    title: "Compilazione del foglio formazione",
    points: [
      "Entrambe le squadre compilano il modulo formazione; il capitano ospitante compila il Foglio Unico di Schieramento con orari, ordine incontri e risultati.",
      "Il foglio va firmato obbligatoriamente da entrambi i capitani, pena la sconfitta a tavolino 4-0 o la non omologazione.",
      "Referto gara e foto delle squadre vanno inviati solo via mail a coppadeiclubumbria@gmail.com.",
    ],
  },
  {
    n: 10,
    title: "Accordo tra capitani",
    points: [
      "Su accordo scritto tra capitani sono possibili: cambio campo/giorno/orario, ordine incontri diverso, sostituzioni per infortunio, recuperi su più giornate, numero minimo di giocatori diverso, rinvii per forza maggiore.",
      "In mancanza di accordo, entrambe le squadre perdono a tavolino 4-0 con 2 punti di penalità in classifica.",
      "Recupero delle gare rinviate: entro massimo 30 giorni nella regular season, comunque non oltre l'ultima di campionato di ogni fase.",
    ],
  },
  {
    n: 11,
    title: "Divise e abbigliamento",
    points: [
      "Le squadre devono presentarsi preferibilmente con una divisa di riconoscimento uguale, con il logo del Circolo, decorosa e non di altri sport.",
      "Sono ammessi sponsor tecnici sul vestiario e nel nome della squadra, nei limiti dell'Art. 3.",
    ],
  },
  {
    n: 12,
    title: "Giorni e orari degli incontri",
    points: [
      "L'ospitante dà disponibilità del campo tra sabato e domenica del weekend indicato in calendario; gli incontri si disputano nella stessa giornata.",
      "Variazioni solo con accordo tra capitani; in caso di mancato rispetto, sconfitta a tavolino 4-0.",
      "Recuperi: massimo 30 giorni nella regular season; ultima giornata e playoff possono solo essere anticipati.",
    ],
  },
  {
    n: 13,
    title: "Calendario della competizione",
    points: [
      "Inizio: secondo weekend di ottobre 2026, poi ogni 15 giorni circa nei weekend successivi.",
      "Termine perentorio iscrizioni: 15 settembre 2026.",
      "Finali regionali: orientativamente la penultima settimana di maggio 2027 (23 maggio), salvo posticipi.",
    ],
  },
  {
    n: 14,
    title: "Obblighi dell'affiliato ospitante",
    points: [
      "Rendere disponibile almeno un campo da gioco.",
      "Fornire 2 tubi da 3 palline nuove per ciascuna gara.",
      "Trasmettere al termine della giornata le foto delle squadre e comunicare eventuali rinvii con la nuova data concordata.",
    ],
  },
  {
    n: 15,
    title: "Validità degli incontri",
    points: [
      "Non sono validi gli incontri con quota campo non saldata, giocatori non tesserati MSP, meno di 6 giocatori presenti, formazione non compilata o foglio unico non inviato.",
      "I ricorsi vanno presentati entro 30 minuti dal termine degli incontri, solo via mail, con allegata la ricevuta di pagamento prevista dall'Art. 17; oltre questo termine il risultato è omologato.",
    ],
  },
  {
    n: 16,
    title: "Rinvio",
    points: [
      "Gli incontri possono essere rinviati solo per pioggia, impedimenti pubblici o accordo tra capitani; recupero entro massimo 30 giorni nella regular season, comunque non oltre l'ultima giornata di campionato di ogni fase.",
    ],
  },
  {
    n: 17,
    title: "Giustizia sportiva e ricorsi",
    points: [
      "Il Giudice Sportivo è nominato dal responsabile del Settore Padel MSP Italia; i ricorsi di 1º grado vanno presentati entro mezz'ora dal termine dell'incontro.",
      "Costo ricorso di 1º grado: 200 € (IBAN IT21S0306905020100000075456, intestato a Massimo Vannini); ricorso di 2º grado: 500 €.",
      "La mail di riferimento per i ricorsi è esclusivamente coppadeiclubumbria@gmail.com.",
    ],
  },
  {
    n: 18,
    title: "Conclusione",
    points: [
      "Per quanto non espressamente contemplato, valgono le norme della Federazione di riferimento.",
    ],
  },
];
